import { render, staticRenderFns } from "./Page9.vue?vue&type=template&id=9e37bf82&scoped=true&"
import script from "./Page9.vue?vue&type=script&lang=ts&"
export * from "./Page9.vue?vue&type=script&lang=ts&"
import style0 from "./Page9.vue?vue&type=style&index=0&id=9e37bf82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e37bf82",
  null
  
)

export default component.exports